// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CouponSubmitDocumentsRequestModel {
    'docType': number;
    'files': Array<RequestFile>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CouponSubmitDocumentsRequestModel>> = [
        {
            "name":     "docType",
            "baseName": "docType",
            "type":     "number"
        },
        {
            "name":     "files",
            "baseName": "files",
            "type":     "Array<RequestFile>"
        },
    ];

    static getAttributeTypeMap() {
        return CouponSubmitDocumentsRequestModel.attributeTypeMap;
    }
}
